import { useEffect, useState } from 'react';
import {
    Button,
    Box,
    Stack,
    Typography,
    FormControl,
    TextField,
    InputLabel,
    Select,
    MenuItem
} from '@mui/material';
import { SelectAllFromTable, SelectColumnFromTableRow, SelectGenericFromTable } from '../universal/Axios';
import apiClient from '../../apiClient';
import { getStore } from '../../Store'

const store = getStore();

const CreateGenAlgSelectionConfig = () => {
    const queryParameters = new URLSearchParams(window.location.search)
    const passedID = queryParameters.get("id")

    const [genAlgSelectionConfigID, setGenAlgSelectionConfigID] = useState("")
    const [description, setDescription] = useState("")

    const [selectionMechanisms, setSelectionMechanisms] = useState([])
    const [selectionMechanismValues, setSelectionMechanismValues] = useState([])
    const [existingSelectionMechanismValues, setExistingSelectionMechanismValues] = useState([])
    const [errors, setErrors] = useState([])


    const [isSubmitButtonDisabled, setSubmitButtonDisabled] = useState(true)

    const selectionMechanismTotalValuesErrorText = "Selection Mechanism allocations must sum to 1."

    useEffect(() => {
        let tempSelectionMechanisms = []
        existingSelectionMechanismValues.map(x => { tempSelectionMechanisms[x.selection_mechanism_id] = x.normalized_weight })
        setSelectionMechanismValues(tempSelectionMechanisms)
    }, [existingSelectionMechanismValues])

    useEffect(() => {
        if (passedID !== null) {
            setGenAlgSelectionConfigID(passedID)
            SelectGenericFromTable("select * from gen_alg_selection_mechanism_selection_config_mapping where gen_alg_selection_config_id = '" + passedID + "';", setExistingSelectionMechanismValues)
            SelectColumnFromTableRow("select description from gen_alg_selection_config where id = '" + passedID + "';", "description", setDescription)
        }
    }, [passedID])

    useEffect(() => {
        SelectGenericFromTable("select * from selection_mechanism;", setSelectionMechanisms)
    }, [])

    useEffect(() => {
        if (genAlgSelectionConfigID !== "" && errors.length == 0) {
            setSubmitButtonDisabled(false)
        }
        else {
            setSubmitButtonDisabled(true)
        }
    }, [genAlgSelectionConfigID, errors]);

    const createGenAlgSelectionConfig = () => {
        store.updateStatusMessage("Creating gen alg selection config...")
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            {
                "function_to_execute": "Create_Gen_Alg_Selection_Config",
                "id": genAlgSelectionConfigID,
                "description": description,
                "selection_mechanism_values": selectionMechanismValues,
            }
        ).then(() => {
            store.updateSuccessMessage("Successfully created gen alg selection config!")
            //window.location.href = "/edit-gen-alg-run?passedID=" + genAlgSelectionConfigID
            window.location.href = "/gen-alg-selection-configs"
        }).catch(function (error) {
            store.updateStatusMessage("Gen alg run creation failed")
            console.log(error)
            if (error?.response?.status === 401) {
                //handleautherror(dispatch)
            } else {

            }
        });
    }

    useEffect(() => {
        let selection_mechanism_values = Object.keys(selectionMechanismValues).map(function (key) {
            return parseFloat(selectionMechanismValues[key]);
        })
        let totalAllocation = selection_mechanism_values.reduce((a, b) => a + b, 0);
        if (totalAllocation !== 1) {
            if (!errors.includes(selectionMechanismTotalValuesErrorText)) {
                setErrors(errors => errors.concat([selectionMechanismTotalValuesErrorText]))
            }
        }
        else {
            setErrors(errors => errors.filter(x => x !== selectionMechanismTotalValuesErrorText))
        }
    }, [selectionMechanismValues])

    const onSelectionMechanismChange = (selectionMechanism, value) => {
        setSelectionMechanismValues({ ...selectionMechanismValues, [selectionMechanism]: value })
        console.log(selectionMechanismValues)
    }

    return (
        <Box>
            <Typography variant="h5">{passedID === null ? "Create" : "View"} Gen Alg Selection Config</Typography>
            <Box sx={{ height: '80px' }}>
                <FormControl style={{ width: '85%', marginTop: '25px', marginRight: '20px' }}>
                    <TextField
                        id="id"
                        label="Gen Alg Selection Config ID"
                        onChange={(event) => passedID === null ? setGenAlgSelectionConfigID(event.target.value) : undefined}
                        required
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={genAlgSelectionConfigID}
                    />
                </FormControl>
            </Box>
            <Box sx={{ height: '80px' }}>
                <FormControl style={{ width: '85%', marginTop: '25px' }}>
                    <TextField
                        id="description"
                        label="Description"
                        onChange={(event) => passedID === null ? setDescription(event.target.value) : undefined}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={description}
                    />
                </FormControl>
            </Box>
            <br />
            <Typography variant="h6">Selection Mechanisms:</Typography>
            {errors.map(x => <div style={{ color: "red" }}>{x}</div>)}
            <Box sx={{ m: 2, marginBottom: '5px', width: '500px' }} spacing={1}>
            {selectionMechanisms && selectionMechanisms?.map(selectionMechanism =>
                <Stack direction="row" spacing={1} style={{ marginBottom: '10px'}}>
                    <TextField 
                        sx = {{ width: '516px' }}
                        value={selectionMechanism.id} 
                    label="Selection Mechanism" />
                    <TextField 
                        value={selectionMechanism.id in selectionMechanismValues ? selectionMechanismValues[selectionMechanism.id] : 0} 
                        onChange={(event) => passedID === null ? onSelectionMechanismChange(selectionMechanism.id, event.target.value) : undefined}
                    label="Value" />
                </Stack>
                )}
            </Box>
            <Box sx={{ m: 2, height: '10px', }}>
                <Box style={{ width: '48%', height: '10px', display: 'inline-block', float: 'left' }}>
                    <Box sx={{ m: 2 }}>
                        <Stack direction="row" spacing={1} justifyContent="flex-end">
                            <Button variant="outlined" href={"gen-alg-selection-configs"}>Cancel</Button>
                        {passedID === null && <Button variant="outlined" onClick={() => createGenAlgSelectionConfig()} disabled={isSubmitButtonDisabled}>Submit</Button>}
                        </Stack>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default CreateGenAlgSelectionConfig;
